import { render } from "./ButtonBlueSecondary.vue?vue&type=template&id=4295c449"
import script from "./ButtonBlueSecondary.vue?vue&type=script&lang=js"
export * from "./ButtonBlueSecondary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__